module.exports = __webpack_public_path__ + "static/media/katie.a3deec3a.jpg";